import * as React from "react";
import Comment from "./Comment";
import "./CommentList.styl";
import DiscussionModel from "../models/DiscussionModel";
import ButtonExpand from "./ButtonExpand";
import Context from "./Context"

export default class CommentList extends React.Component<{
    model: DiscussionModel;
}> {

    public render(): React.ReactNode {
        return (
            <Context.Consumer>
                {({fullwidth}) => (
                    <div className="Discussion-CommentList-Root">
                        {this.renderItems(fullwidth)}
                    </div>
                )}
            </Context.Consumer>
        );
    }

    private renderItems(fullwidth: boolean): React.ReactNodeArray {

        const model = this.props.model;
        const user = model.getUser();
        const admin = model.isAdmin();
        const authors = model.getAuthors();
        const elements: React.ReactNodeArray = [];
        const badges = model.getBadges();

        let parent: number = 0;
        let expaned: boolean = true;
        let children: number = 0;

        model.getComments().forEach((comment) => {
            const rating = model.getRating(comment.getCommentId());

            if (comment.getParentId() == 0) {

                if (!expaned && children > 4) {
                    elements.push(
                        <ButtonExpand parent={parent} count={children - 4} key={"E" + comment.getCommentId()}/>
                    );
                }

                parent = comment.getCommentId();
                expaned = model.isExpaned(parent);
                children = 0;

            } else {
                children = children + 1;
            }

            if (expaned || children <= 4) {
                elements.push(
                    <div
                        className="Discussion-CommentList-Gap"
                        key={"L-" + comment.getCommentId()}
                        data-level={comment.getLevel()}
                        data-first={comment.isFirst() ? "1" : "0"}
                        data-last={comment.isLast() ? "1" : "0"}
                        data-children={comment.hasChildren() ? "1" : "0"}
                        data-previous={comment.hasPrevious() ? "1" : "0"}
                        data-fullwidth={fullwidth ? "1" : "0"}
                    />,
                    <div
                        className="Discussion-CommentList-Item"
                        key={"C-" + comment.getCommentId()}
                        data-level={comment.getLevel()}
                        data-first={comment.isFirst() ? "1" : "0"}
                        data-last={comment.isLast() ? "1" : "0"}
                        data-children={comment.hasChildren() ? "1" : "0"}
                        data-previous={comment.hasPrevious() ? "1" : "0"}
                        data-fullwidth={fullwidth ? "1" : "0"}
                    >
                        <Comment
                            model={model}
                            comment={comment}
                            rating={rating}
                            user={user}
                            authors={authors}
                            admin={admin}
                            badges={badges}
                        />
                    </div>,
                );
            }

        });

        if (!expaned && children > 4) {
            elements.push(
                <ButtonExpand parent={parent} count={children - 4} key={"E-END"}/>
            );
        }

        elements.push(
            <div
                className="Discussion-CommentList-Gap"
                key={"L-END"}
                data-level={0}
                data-first={false}
                data-last={false}
                data-children={false}
                data-previous={false}
                data-fullwidth={fullwidth ? "1" : "0"}
            />
        );

        return elements;

    }

}